import {
  HOST_HUB_TAB_IDS,
  HOST_HUB_TAB_PATHS,
} from "../../constants/host-hub.consts";

import type { HostHubNavLink } from "./HostHubNavigation.types";

export const NAV_LINKS: readonly HostHubNavLink[] = [
  {
    href: HOST_HUB_TAB_PATHS.overview,
    id: HOST_HUB_TAB_IDS.overview,
    title: {
      defaultMessage: "Overview",
      id: "host_hub.tab.overview",
    },
  },
  {
    href: HOST_HUB_TAB_PATHS.metrics,
    id: HOST_HUB_TAB_IDS.metrics,
    title: {
      defaultMessage: "Metrics",
      id: "host_hub.tab.metrics",
    },
  },
];
